var _excluded = ["initialState", "onLastStepComplete", "steps", "text"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { createContext, useContext, useState } from 'react';
import merge from 'lodash.merge';
import { jsx as ___EmotionJSX } from "@emotion/react";
var defaultText = {
  buttons: {
    last: 'Complete',
    next: 'Continue',
    previous: 'Previous'
  },
  progressHeading: (currentStep, stepCount) => "Step " + currentStep + " of " + stepCount
};
var ModalStepsContext = /*#__PURE__*/createContext({
  activeStep: {
    content: null,
    heading: ''
  },
  goToNextStep: () => {},
  goToPreviousStep: () => {},
  goToStep: () => {},
  isFirstStep: () => false,
  isLastStep: () => false,
  setLoading: loadingState => loadingState,
  onLastStepComplete: function onLastStepComplete(close) {
    if (close === void 0) {
      close = () => {};
    }
    return close();
  },
  setState: state => state,
  state: {},
  steps: [],
  text: defaultText
});
export var ModalStepsProvider = _ref => {
  var {
      initialState = {},
      onLastStepComplete,
      steps = [],
      text = {}
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var [activeStepIndex, setActiveStepIndex] = useState(0);
  var [stepIndexHistory, setStepIndexHistory] = useState([]);
  var {
    [activeStepIndex]: activeStep
  } = steps;
  var goToNextStep = () => {
    if (isLastStep()) {
      return;
    }
    var currentStepIndex = steps.indexOf(activeStep);
    var nextStepIndex = currentStepIndex + 1;
    if (activeStep.nextStepId) {
      nextStepIndex = steps.findIndex(_ref2 => {
        var {
          id
        } = _ref2;
        return id === activeStep.nextStepId;
      });
    }
    stepIndexHistory.push(currentStepIndex);
    setStepIndexHistory([...stepIndexHistory]);
    setActiveStepIndex(nextStepIndex);
  };
  var goToPreviousStep = () => {
    if (isFirstStep()) {
      return;
    }
    var previousStepIndex = stepIndexHistory.pop() || 0;
    setStepIndexHistory([...stepIndexHistory]);
    setActiveStepIndex(previousStepIndex);
  };
  var isFirstStep = () => activeStepIndex === 0;
  var isLastStep = () => activeStepIndex === steps.length - 1;
  var setLoading = _ref3 => {
    var {
      loading,
      description
    } = _ref3;
    setState(_extends({}, state, {
      loading,
      loadingDescription: description
    }));
  };
  var [state, setState] = useState(initialState);
  return ___EmotionJSX(ModalStepsContext.Provider, _extends({
    value: {
      activeStep,
      goToNextStep,
      goToPreviousStep,
      goToStep: setActiveStepIndex,
      isFirstStep,
      isLastStep,
      setLoading,
      onLastStepComplete,
      state,
      setState,
      steps,
      text: merge(defaultText, text)
    }
  }, props));
};
export function useModalStepsContext() {
  return useContext(ModalStepsContext);
}
export function withModalStepsContext(Component) {
  var ComponentWithModalStepsContext = props => {
    var context = useModalStepsContext();
    return ___EmotionJSX(Component, _extends({}, context, props));
  };
  return ComponentWithModalStepsContext;
}